import { ActionsButtonItem } from '../../../../ui/components/pure/actions-button/actions-button.types';
import { Import } from '../../../../ui/components/pure/icons/Import.icon';
import { Download } from '../../../../ui/components/pure/icons/Download.icon';
import { makeDefineActions } from '../../../../ui/components/pure/actions-button/actions-button.helpers';
import { Permissions } from '../../../../core/permissions/permissions.typings';

export enum CourierListActions {
  ADD_COURIER = 'ADD_COURIER',
  ADD_COURIER_SUCCESS = 'ADD_COURIER_SUCCESS',
  BATCH_IMPORT = 'BATCH_IMPORT',
  BATCH_IMPORT_SUCCESS = 'BATCH_IMPORT_SUCCESS',
  BATCH_EXPORT = 'BATCH_EXPORT',
  BATCH_EXPORT_SUCCESS = 'BATCH_EXPORT_SUCCESS'
}

function makeCouriersListActions(projectID: string): ActionsButtonItem<CourierListActions>[] {
  return [
    {
      title: 'Batch import',
      Icon: Import,
      action: CourierListActions.BATCH_IMPORT,
      permission: {
        action: Permissions.users.batchImport,
        projectID
      }
    },
    {
      title: 'Batch export',
      Icon: Download,
      action: CourierListActions.BATCH_EXPORT
    }
  ];
}

export function makeDefineCouriersListActions(projectID: string) {
  return makeDefineActions(makeCouriersListActions(projectID));
}
